import { Link } from "react-router-dom";

export function Hero() {
  return (
    <section className="t-hero" data-section="hero">
      <div className="t-hero-split">
        <div className="t-hero-copy">
          <p className="t-kicker">3D product renders for small sellers</p>
          <h1 className="t-hero-title">Turnstill</h1>
          <p className="t-hero-lead">
            360 spins, hero stills and ad creatives made in Blender from your product. No photo
            shoot, no shipping samples across the country.
          </p>
          <div className="t-actions">
            <Link to="/quote" className="t-btn t-btn-primary">
              Request a quote
            </Link>
            <Link to="/packages" className="t-btn t-btn-secondary">
              See packages
            </Link>
          </div>
        </div>
        <figure className="t-hero-visual">
          <img
            className="t-hero-img"
            src="/work/hero.jpg"
            width={1600}
            height={900}
            alt="Studio render of a white candle warmer lamp over a glass candle, lit from within"
          />
          <figcaption className="t-hero-frame-label">Self-initiated project: Waft candle warmer concept</figcaption>
        </figure>
      </div>
    </section>
  );
}
